import React from "react";
import classnames from "classnames";
import { formatCurrency } from "@src/utils/currency";
import { useCurrentUserStore } from "@src/state/currentUserState";
import styles from "./PriceDisplay.module.scss";

interface PriceDisplayProps {
  amount?: number | null;
  suffix?: string;
  unavailableText?: string;
  className?: string;
  "data-testid"?: string;
}

export default function PriceDisplay({
  amount,
  suffix = "",
  unavailableText,
  className,
  "data-testid": dataTestId,
}: PriceDisplayProps) {
  const { currentUser } = useCurrentUserStore();
  const isDemoMode = currentUser?.demoMode ?? false;

  const text =
    typeof amount === "number"
      ? `${formatCurrency(amount)}${suffix}`
      : (unavailableText ?? "Price Unavailable");

  return (
    <span
      className={classnames(className, { [styles.blurred]: isDemoMode })}
      data-testid={dataTestId}
    >
      {text}
    </span>
  );
}
